import { Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import HomePage from "../pages/main/HomePage";
import ProductNav from "./shared/ProductNav";
import CategoryNav from "./shared/CategoryNav";
import ShopNav from "./shared/ShopNav";
import CartPage from "../pages/main/panier/page";
import NotFound from "../pages/main/NotFoundPage";
import CheckoutPage from "../pages/main/checkout/page";
import ContactPage from "../pages/main/contact/page";
import PrivacyPage from "../pages/main/politique-confidentialite/page";
import ConditionsPage from "../pages/main/conditions/page";


export default function MainNav() {
  return (
    <MainLayout>
      <Routes>

        <Route path="/" element={<HomePage />} />
        <Route path="/products/*" element={<ProductNav />} />
        <Route path="/categories/*" element={<CategoryNav />} />
        <Route path="/boutiques/*" element={<ShopNav />} />
        <Route path="/panier" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/politique-confidentialite" element={<PrivacyPage />} />
        <Route path="/conditions" element={<ConditionsPage />} />

        <Route path="*" element={<NotFound />} />

      </Routes>
    </MainLayout>
  )
}
